import React, { useState, useEffect } from "react";
import CreateLecture from "../components/CreateLecture";
import AdminLectureCard from "../components/AdminLectureCard";
import AdminLectureFilterComp from "../components/AdminLectureFilterComp";
import Utils from "../utils/utils";
import AdminLectureComp from "../components/AdminLectureComp";

const AdminLectures = () => {
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const admin = Utils.getLoggedInUser();
  const token = Utils.getToken();

  const [lectures, setLectures] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [courseData, setCoursesData] = useState(["PGP", "AI", "WEB"]);

  const [limit, setLimit] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCounts, setTotalCounts] = useState(0);
  const [lectureToView, setLectureToView] = useState(null);

  const [filterQuery, setFilterQuery] = useState({
    title: "",
    remarks: "",
    course: "PGP",
    category: "Coding",
    instructorName: "",
    lectureMode: "",
    from: "",
    upto: "",
    batch: "",
  });
  const [lectureFor, setLectureFor] = useState("today");

  const fetchBatches = async (activeBatch) => {
    try {
      const response = await fetch(`${SERVER_URL}/batch/${activeBatch}`, {
        method: "GET",
        // mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: `${token}`,
        },
      });
      if (response.status === 200) {
        const res = await response.json();
        const onlyBatch = res.map((batch) => batch.batch);
        setBatchData(onlyBatch);
      } else {
        const res = await response.json();
        alert(res.message);
        // Handle other response codes or errors here
        console.error("Data Retreieval:", res.message);
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Retreieval failed:", error);
    }
  };

  const fetchLecturesData = async () => {
    const queryObj = filterQuery;
    if (queryObj.from)
      queryObj["from"] = new Date(`${queryObj.from} 18:30:00:000Z`).toJSON();
    if (queryObj.upto)
      queryObj["upto"] = new Date(`${queryObj.upto} 18:30:00:000Z`).toJSON();
    const query = `title=${queryObj.title}&remarks=${queryObj.remarks}&course=${queryObj.course}&category=${queryObj.category}&lectureMode=${queryObj.lectureMode}&from=${queryObj.from}&upto=${queryObj.upto}&batch=${queryObj.batch}&page=${currentPage}&limit=${limit}`;

    try {
      let response = await fetch(`${SERVER_URL}/lectures/all?${query}`, {
        method: "GET",
        // mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: `${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        setLectures((prev) => {
          return [...data.lectures];
        });
        setCurrentPage((pre) => {
          return data.currentPage;
        });
        setTotalPages((pre) => {
          return data.totalPages;
        });
        setTotalCounts((pre) => {
          return data.totalCounts;
        });
      } else {
        response = await response.json();
        alert(response.message);
      }
    } catch (error) {
      console.error("Error : ", error);
    }
  };

  const fetchLecturesFor = async function (typeOfLecture) {
    const startDate = new Date(new Date().setHours(0, 0, 0, 0)).toJSON();
    const endDate = new Date(new Date().setHours(23, 59, 59, 999)).toJSON();
    const query = `title=${filterQuery.title}&category=${filterQuery.category}&lectureMode=${filterQuery.lectureMode}&instructorName=${filterQuery.instructorName}&limit=${limit}&page=${currentPage}`;

    const urls = {
      today: `${SERVER_URL}/lectures/admin/today?start=${startDate}&end=${endDate}`,
      upcoming: `${SERVER_URL}/lectures/admin/upcoming?end=${endDate}`,
      all: `${SERVER_URL}/lectures/all?${query}`,
    };

    try {
      const customURL = urls[typeOfLecture];
      let response = await fetch(customURL, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `${token}`,
        },
      });
      if (response.ok) {
        const data = await response.json();
        // console.table(data);
        setLectures((prev) => {
          return [...data.lectures];
        });
        setCurrentPage((pre) => {
          return data.currentPage;
        });
        setTotalPages((pre) => {
          return data.totalPages;
        });
        setTotalCounts((pre) => {
          return data.totalCounts;
        });
      } else {
        const errorData = await response.json();
        alert(errorData.message);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleLectureClick = (lecture) => {
    const lectureTime = lecture.lectureTime;
    const joiningLink = lecture.joiningLink;
    const videoLink = lecture.videoLink;
    let originalLectureTime = new Date(lectureTime);
    let currentTime = new Date(new Date().toUTCString());

    if (currentTime >= originalLectureTime) {
      if (videoLink && videoLink !== "false") {
        setLectureToView(lecture);
      } else if (joiningLink) {
        window.open(joiningLink, "_blank");
      } else {
        alert(
          "There is some error in joining in the lecture. Report Admin !!!"
        );
        return;
      }
    } else {
      const LectureTime = Utils.getIndianTimeFromJSON(lectureTime);
      alert(`Lecture will be available at ${LectureTime}.`);
    }
  };

  const closeLectureComp = () => {
    setLectureToView(null); // Close the modal
  };

  useEffect(() => {
    fetchBatches(filterQuery.course);
  }, []);

  useEffect(() => {
    fetchLecturesFor(lectureFor);
  }, [filterQuery, lectureFor, currentPage, limit]);

  useEffect(() => {
    setLectureToView(lectureToView);
  }, [lectureToView]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilterQuery({ ...filterQuery, [name]: value });
  };

  const handleResetFilter = (e) => {
    e.preventDefault();
    setFilterQuery({
      title: "",
      remarks: "",
      course: "PGP",
      category: "Coding",
      lectureMode: "",
      instructorName: "",
      from: "",
      upto: "",
      batch: "",
    });
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage((prev) => {
        return newPage;
      });
    }
  };

  return (
    <div
      bkl="AdminLectures"
      className="shadow-none relative overflow-x-hidden p-4 overflow-y-auto scrollbar-thin space-y-4 h-[calc(100vh-65px)]"
    >
      <div className="flex">
        <CreateLecture token={token} />
      </div>

      <AdminLectureFilterComp
        filterQuery={filterQuery}
        handleInputChange={handleInputChange}
        courseData={courseData}
        batchData={batchData}
        lectureFor={lectureFor}
        setLectureFor={setLectureFor}
        fetchLecturesData={fetchLecturesData}
        handleResetFilter={handleResetFilter}
      />

      <div
        bkl="AdminLecturesListComp"
        key="AdminLecturesListComp"
        className="mt-2 w-full "
      >
        <div
          className="flex flex-col gap-4 items-center w-full text-sm pb-2"
          key="AdminLecturesLists"
        >
          {lectures.map((lecture, index) => (
            <AdminLectureCard
              props={{
                admin,
                token,
                lecture,
                index,
                batchData,
                lectureFor,
                setLectures,
                handleLectureClick,
              }}
            />
          ))}
        </div>
      </div>
      {lectureToView && (
        <AdminLectureComp lecture={lectureToView} onClose={closeLectureComp} />
      )}

      <div
        className="fixed bottom-0 shadow-xl bg-gray-100 right-0 pl-3 pr-3 pt-1 pb-1 max-w-[calc(100%-18rem)] w-full z-20 flex items-center justify-between"
        blk="PaginationContainerInStudents"
        style={{ fontSize: "12px" }}
      >
        <div className="bg-white rounded-md px-2">
          <p className="text-8px font-semibold text-gray-700 flex items-center space-x-2">
            <span className="text-8px">Showing</span>
            <button className="join-item btn btn-xs">{lectures.length}</button>
            <span>out of</span>
            <button className="join-item btn btn-xs">{totalCounts}</button>
            <span>records</span>
          </p>
        </div>
        <div className="flex justify-end bg-white">
          <div className="flex items-center">
            <select
              className="select select-xs outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none mr-2"
              value={limit}
              onChange={(e) => {
                setLimit((prev) => {
                  return e.target.value;
                });
              }}
            >
              <option disabled defaultValue={limit}>
                {limit}
              </option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
            </select>
            <p className="mr-3 text-gray-500">per page</p>
          </div>

          <div className="join">
            <button
              className="join-item btn btn-xs"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              «
            </button>
            <button className="join-item btn btn-active btn-xs">{`Page ${currentPage}`}</button>
            <button
              className="join-item btn btn-xs"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              »
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLectures;
